import axios from 'axios';
import Vue from 'vue';

import Errors from '../classes/Errors';

Vue.component('form-component', {
    data() {
        return {
            errors: new Errors(),
            formCompleted: false,
            isSubmitting: false,
            formType: null,
        };
    },

    props: {
        initialType: String,
        initialProduct: String,
        siteKey: {
            type: String,
            required: false,
        },
        recaptcha: {
            type: Boolean,
            required: true,
        },
    },

    mounted() {
        if (this.initialType) {
            this.formType = this.initialType;
        }
    },

    methods: {
        onSubmit(event) {
            const form = event.currentTarget;

            if (this.isSubmitting) {
                return;
            }

            this.isSubmitting = true;

            if (this.recaptcha) {
                grecaptcha.ready(() => {
                    grecaptcha
                        .execute(this.siteKey, {
                            action: 'submit',
                        })
                        .then((token) => {
                            document.getElementById('recaptchaToken').value =
                                token;

                            axios
                                .post('/', new FormData(form))

                                .then((response) => {
                                    this.isSubmitting = false;
                                    const result = response.data;

                                    if (result.data && result.data.errors) {
                                        this.errors.clear();
                                        this.errors.record(result.data.errors);
                                        return;
                                    }

                                    this.formCompleted = true;
                                    this.errors.clear();

                                    if (this.$refs.redirectUrl) {
                                        window.location =
                                            this.$refs.redirectUrl.value;
                                    }
                                })

                                .catch((error) => {
                                    this.isSubmitting = false;
                                    console.log(error);
                                });
                        });
                });
            } else {
                axios
                    .post('/', new FormData(form))

                    .then((response) => {
                        this.isSubmitting = false;
                        const result = response.data;

                        if (result.data && result.data.errors) {
                            this.errors.clear();
                            this.errors.record(result.data.errors);
                            return;
                        }

                        this.formCompleted = true;
                        this.errors.clear();

                        if (this.$refs.redirectUrl) {
                            window.location = this.$refs.redirectUrl.value;
                        }
                    })

                    .catch((error) => {
                        this.isSubmitting = false;
                        console.log(error);
                    });
            }
        },
    },
});
